import {gsap, ScrollTrigger} from "gsap/all";

gsap.registerPlugin(ScrollTrigger);
gsap.config({nullTargetWarn: false});

class sideMenuInit  {
    constructor() {
        this.target = [...document.querySelectorAll('.section-side-menu')];
        if(this.target.length > 0) this.init();
    }

    init() {
        this.mainAnimations();
        ScrollTrigger.addEventListener("refreshInit", () => {
            this.debounce(this.mainAnimations, 300)
        })
    }

    debounce(func, delay) {
        let timer;
        return (args)=> {
            clearTimeout(timer);
            timer = setTimeout(() => {
                func.apply(this, args);
            }, delay);
        };
    }


     mainAnimations() {
        ScrollTrigger.getAll().forEach(ST => {
            if (ST.trigger.classList.contains('section-side-menu')) ST.kill();
        });

        [...this.target].forEach((section) => {
            let mm = gsap.matchMedia();
            mm.add("(min-width: 1000px)", () => {
                const links = gsap.utils.toArray(".anim-menu__links li");

                const tl = gsap.timeline({
                    paused: true,
                    ease: 'none',
                    scrollTrigger: {
                        trigger: section,
                        start: "bottom bottom",
                        end: "+=200%",
                        toggleActions: "play none none reverse",
                        scrub: true,
                        pin: true,
                    },
                });

                links.forEach((item, index) => {
                    tl.add(() => {
                        if (index !== 0) item.classList.add('active');

                        if (item.classList.contains('past')) {
                            item.classList.remove('past');
                            if (index !== links.length - 1) links[index + 1].classList.remove('active');
                            if (!item.classList.contains('active')) item.classList.add('active');
                        }

                        section.querySelector('.anim-menu__panel.active').classList.remove('active');
                        section.querySelector(`#${item.dataset.id}`).classList.add('active');
                    })
                    tl.fromTo(item.querySelector('.anim-line'), {duration: 0.5, bottom: '100%'}, {bottom: 0})
                    tl.add(() => {
                        item.classList.add('past');
                        if (index !== links.length - 1 && item.classList.contains('active')) item.classList.remove('active');
                    });
                });
            });
        });
    }
}

export const changeMenuActiveColor = (sectionsWithBg) => {
    const activeSideMenu = document.querySelector('.sticky-menu__link.active');
    if(!activeSideMenu) return;

    sectionsWithBg.forEach(section => {
        if (section.getBoundingClientRect().top <= activeSideMenu.getBoundingClientRect().top) {
            section != document.querySelector('.inViewport') ? document.querySelector('.inViewport')?.classList.remove('inViewport') : null;
            section.classList.add('inViewport');
        }

        if (section.classList.contains('inViewport') && section.classList.contains('bg-blue-400')) {
            activeSideMenu.classList.add('active--white');
        } else if (section.classList.contains('inViewport') && !section.classList.contains('bg-blue-400')) {
            document.querySelector('.active--white')?.classList.remove('active--white');
        }
    })
}


export default sideMenuInit;